import React from 'react';
import isFunction from 'lodash/isFunction';
import {
  formatMoney,
} from '@populateui/utils';
import ExpandIcon from 'core/icons/expand';
import {
  ChargesRowData,
} from 'pages/Dashboard/pages/Billing/types';
import AmountTag, {
  Props as AmountTagProps,
} from 'pages/Dashboard/pages/Billing/AmountTag';

type Props = Pick<AmountTagProps, 'classes' | 'tooltip' | 'onClick' | 'useColors'> & {
  isTag?: boolean;
  total?: number;
};

export default function TotalCell({
  isTag = false,
  tooltip,
  onClick,
  classes,
  useColors = true,
  total,
}: ChargesRowData & Props) {
  return (
    <div className="w-full flex justify-between items-center gap-2 !text-[11px]">
      {isTag
        ? (
          <AmountTag
            tooltip={tooltip}
            onClick={onClick}
            useColors={useColors}
            classes={classes}
            conditionalValue={total}
          >
            <div className="flex items-center gap-1 !text-[12px] ">
              {formatMoney(total ?? 0)}
              {isFunction(onClick) && <ExpandIcon className="!w-2.5 !h-2.5 !text-inherit" />}
            </div>
          </AmountTag>
        )
        : formatMoney(total ?? 0)}
    </div>
  );
}
